import React from 'react';

/**
 * StethoscopeAI — lucide Stethoscope icon with AI sparkle stars overlay.
 * Accepts the same `size` prop as lucide-react icons for drop-in compatibility.
 */
export function StethoscopeAI({ size = 24, className = '', ...props }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 -3 24 27"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      {...props}
    >
      {/* Lucide Stethoscope paths (unchanged) */}
      <path d="M11 2v2" />
      <path d="M5 2v2" />
      <path d="M5 3H4a2 2 0 0 0-2 2v4a6 6 0 0 0 12 0V5a2 2 0 0 0-2-2h-1" />
      <path d="M8 15a6 6 0 0 0 12 0v-3" />
      <circle cx="20" cy="10" r="2" />

      {/* AI sparkle — large 4-point star */}
      <path
        d="M19 0l0.6 1.4L21 2l-1.4 0.6L19 4l-0.6-1.4L17 2l1.4-0.6Z"
        fill="currentColor"
        stroke="none"
      />

      {/* AI sparkle — small 4-point star */}
      <path
        d="M15.5-1l0.35 0.85 0.85 0.35-0.85 0.35L15.5 1.4l-0.35-0.85-0.85-0.35 0.85-0.35Z"
        fill="currentColor"
        stroke="none"
      />

      {/* AI sparkle — tiny accent dot */}
      <circle cx="22" cy="0" r="0.6" fill="currentColor" stroke="none" />
    </svg>
  );
}
